'use client';
import React, { useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';

// ─── Types ───────────────────────────────────────────────────────────────────
interface Review {
  name: string;
  rating: number;
  text: string;
  image: string;
  alt: string;
}

interface ServiceCategory {
  icon: string;
  title: string;
  items: string[];
}

interface WhyCard {
  title: string;
  description: string;
}

// ─── Data ────────────────────────────────────────────────────────────────────
const services: ServiceCategory[] = [
{
  icon: '✂️',
  title: 'Hair Care',
  items: [
  'Hair Smoothening',
  'Kerasmooth with Treatment',
  'Hair Spa',
  'Trendy Haircuts',
  'Hair Keratin',
  'Hair Extensions',
  'Hair Transplant']

},
{
  icon: '💄',
  title: 'Makeup & Bridal',
  items: [
  'Bridal Makeup',
  'Party Makeup',
  'Makeovers (Occasion / Photoshoot / Personal Styling)']

},
{
  icon: '💅',
  title: 'Nails & Beauty',
  items: [
  'Nail Art & Gel Polish',
  'Eyelash Extensions',
  'Microblading (Brows)',
  'Lip Coloring',
  'Tattoo Art',
  'Piercing (Ears and Nose)',
  'Baby Piercing']

},
{
  icon: '💆‍♂️',
  title: 'Skin & Body',
  items: [
  'Wine Facial',
  'Aroma Therapy',
  'Body Polishing',
  'Customized Facials',
  'Skin Treatments',
  'Hydra Facial',
  'Pedicure',
  'Manicure']

}];


const reviews: Review[] = [
{
  name: 'Shruti Das',
  rating: 5,
  text: 'Amazing service! My hair treatment went really well. Highly recommended.',
  image: 'https://www.hashtagstudio.in/gellary/1.jpeg',
  alt: 'Shruti Das - Happy customer at Hashtag Hair & Beauty Studio'
},
{
  name: 'Sristi Agarwal',
  rating: 4,
  text: 'Loved the hydrafacial service. The team was super professional!',
  image: 'https://www.hashtagstudio.in/gellary/2.jpeg',
  alt: 'Sristi Agarwal - Satisfied customer at Hashtag Hair & Beauty Studio'
},
{
  name: 'Akash Roy',
  rating: 5,
  text: 'Tattoo service was perfect. Everything was clean and well-managed.',
  image: 'https://www.hashtagstudio.in/gellary/3.jpeg',
  alt: 'Akash Roy - Pleased customer at Hashtag Hair & Beauty Studio'
}];


const whyCards: WhyCard[] = [
{
  title: '✅ Trained Professionals',
  description: 'Expert artists and stylists ensuring quality and care.'
},
{
  title: '✅ Bridal Experts',
  description: 'Specialized in bridal and occasion styling for your big day.'
},
{
  title: '✅ Hygienic Ambience',
  description: 'Clean, comfortable and safe environment for every visit.'
},
{
  title: '✅ Transparent Pricing',
  description: 'Clear and fair pricing for all services without hidden costs.'
},
{
  title: '✅ Trend-Driven Solutions',
  description: 'Up-to-date, safe beauty treatments aligned with trends.'
},
{
  title: '✅ Non-Surgical Treatments',
  description: 'Offering aesthetic non-surgical beauty and wellness solutions.'
}];


const galleryImages = [
{ src: 'https://www.hashtagstudio.in/1.jpg', alt: 'Male Hair Style at Hashtag Studio Kolkata' },
{ src: 'https://www.hashtagstudio.in/2.jpg', alt: 'Female Hair Style at Hashtag Studio Kolkata' },
{ src: 'https://www.hashtagstudio.in/3.jpg', alt: 'Beard Style at Hashtag Studio Kolkata' },
{ src: 'https://www.hashtagstudio.in/4.jpg', alt: 'Classic Style at Hashtag Studio Kolkata' },
{ src: 'https://www.hashtagstudio.in/5.jpg', alt: 'Modern Style at Hashtag Studio Kolkata' },
{ src: 'https://www.hashtagstudio.in/6.jpg', alt: 'Color Style at Hashtag Studio Kolkata' }];


const sliderImages = [
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.29_9b4a386a.jpg', alt: 'Hashtag Studio Instagram post 1' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.30_ee1a0d15.jpg', alt: 'Hashtag Studio Instagram post 2' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.31_02912989.jpg', alt: 'Hashtag Studio Instagram post 3' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.31_149d1135.jpg', alt: 'Hashtag Studio Instagram post 4' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.31_1904e681.jpg', alt: 'Hashtag Studio Instagram post 5' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.31_7618dd40.jpg', alt: 'Hashtag Studio Instagram post 6' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.32_64c9c707.jpg', alt: 'Hashtag Studio Instagram post 7' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.32_f0e921f7.jpg', alt: 'Hashtag Studio Instagram post 8' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.32_fc448662.jpg', alt: 'Hashtag Studio Instagram post 9' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.33_236344d2.jpg', alt: 'Hashtag Studio Instagram post 10' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.33_6fc55e4d.jpg', alt: 'Hashtag Studio Instagram post 11' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.33_f1b8a4d8.jpg', alt: 'Hashtag Studio Instagram post 12' },
{ src: 'https://www.hashtagstudio.in/slider/WhatsApp%20Image%202025-07-15%20at%2001.57.33_8888d9ae.jpg', alt: 'Hashtag Studio Instagram post 13' }];


const nailArtImages = [
{ src: 'https://www.hashtagstudio.in/gellary/IMG-20250726-WA0004.jpg', alt: 'Nail Art design 1 at Hashtag Studio' },
{ src: 'https://www.hashtagstudio.in/gellary/IMG-20250726-WA0005.jpg', alt: 'Nail Art design 2 at Hashtag Studio' },
{ src: 'https://www.hashtagstudio.in/gellary/IMG-20250726-WA0006.jpg', alt: 'Nail Art design 3 at Hashtag Studio' }];


// ─── Sub-components ──────────────────────────────────────────────────────────

function StarRating({ rating }: {rating: number;}) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) =>
      <span key={star} className={star <= rating ? 'text-yellow-400' : 'text-gray-600'} style={{ fontSize: '18px' }}>
          ★
        </span>
      )}
    </div>);

}

function SectionTitle({ children, subtitle }: {children: React.ReactNode;subtitle?: string;}) {
  return (
    <div className="text-center mb-10">
      <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
        <span className="gold-text">{children}</span>
      </h2>
      {subtitle &&
      <p className="text-gray-400 text-lg mt-2">{subtitle}</p>
      }
      <div className="section-divider mt-4" />
    </div>);

}

// ─── Main Component ───────────────────────────────────────────────────────────
export default function HashtagSalonPage() {
  const [currentReview, setCurrentReview] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState('');
  const [modalAlt, setModalAlt] = useState('');
  const [careerModalOpen, setCareerModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: ''
  });
  const sliderRef = useRef<HTMLDivElement>(null);
  const scrollSpeedRef = useRef(0);
  const animFrameRef = useRef<number>(0);

  // Auto-advance reviews
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Slider animation
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const handleMouseMove = (e: MouseEvent) => {
      const rect = slider.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const middle = rect.width / 2;
      const maxSpeed = 4;
      scrollSpeedRef.current = (x - middle) / middle * maxSpeed;
    };

    const handleMouseLeave = () => {
      scrollSpeedRef.current = 0;
    };

    slider.addEventListener('mousemove', handleMouseMove);
    slider.addEventListener('mouseleave', handleMouseLeave);

    const animate = () => {
      if (slider) {
        slider.scrollLeft += scrollSpeedRef.current;
      }
      animFrameRef.current = requestAnimationFrame(animate);
    };
    animFrameRef.current = requestAnimationFrame(animate);

    return () => {
      slider.removeEventListener('mousemove', handleMouseMove);
      slider.removeEventListener('mouseleave', handleMouseLeave);
      cancelAnimationFrame(animFrameRef.current);
    };
  }, []);

  const openModal = (src: string, alt: string) => {
    setModalSrc(src);
    setModalAlt(alt);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalSrc('');
    setModalAlt('');
  };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you! We will contact you shortly.');
    setFormData({ name: '', phone: '', email: '', service: '' });
  };

  const navLinks = [
  { label: 'HOME', href: '#home' },
  { label: 'ABOUT US', href: '#why-us' },
  { label: 'SERVICES', href: '#services' },
  { label: 'OFFERS', href: '#menu' },
  { label: 'CONTACT US', href: '#visit-us' },
  { label: 'WHY US', href: '#why-hashtag' }];


  return (
    <div className="min-h-screen" style={{ backgroundColor: '#000', color: '#fff', fontFamily: 'Segoe UI, sans-serif' }}>
      {/* ── Fullscreen Image Modal ── */}
      {modalOpen &&
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        style={{ backgroundColor: 'rgba(0,0,0,0.92)' }}
        onClick={closeModal}>
        
          <button
          className="absolute top-4 right-8 text-white text-5xl font-light z-50 hover:text-yellow-400 transition-colors"
          onClick={closeModal}
          aria-label="Close modal">
          
            ×
          </button>
          <img
          src={modalSrc}
          alt={modalAlt}
          className="max-w-[95vw] max-h-[95vh] rounded-xl"
          style={{ border: '3px solid #d4af37', boxShadow: '0 0 40px rgba(212,175,55,0.3)' }}
          onClick={(e) => e.stopPropagation()} />
        
        </div>
      }

      {/* ── Career Modal ── */}
      {careerModalOpen &&
      <div
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        style={{ backgroundColor: 'rgba(0,0,0,0.85)' }}
        onClick={() => setCareerModalOpen(false)}>
        
          <div
          className="w-full max-w-2xl rounded-2xl overflow-hidden"
          style={{ background: 'linear-gradient(-45deg, #ff9a9e, #fad0c4, #a1c4fd, #c2e9fb)', backgroundSize: '400% 400%', animation: 'gradientBG 12s ease infinite' }}
          onClick={(e) => e.stopPropagation()}>
          
            <div className="m-4 bg-white rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">Career With Us</h2>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                  <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:border-yellow-500" placeholder="Your full name" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                  <input type="email" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:border-yellow-500" placeholder="you@example.com" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                  <input type="tel" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:border-yellow-500" placeholder="Your phone number" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Position Applied For</label>
                  <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:border-yellow-500" placeholder="E.g. Beautician, Manager" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Message (Optional)</label>
                  <textarea className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:border-yellow-500" rows={3} placeholder="Write a message..." />
                </div>
                <div className="text-center pt-2">
                  <button type="button" onClick={() => setCareerModalOpen(false)} className="px-8 py-2 rounded-lg font-semibold text-white" style={{ background: '#111' }}>Submit Application</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      }

      {/* ══════════════════════════════════════════
           NAVBAR
        ══════════════════════════════════════════ */}
      <nav className="sticky top-0 z-40 w-full" style={{ backgroundColor: '#000', borderBottom: '1px solid rgba(212,175,55,0.3)' }}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3">
            <Image
              src="/assets/images/Hashtag_Logo-1788765015476.jpg"
              alt="Hashtag Hair & Beauty Studio Logo"
              width={50}
              height={50}
              className="rounded-full object-cover"
              style={{ border: '2px solid #d4af37' }} />
            
            <span className="hidden sm:block text-sm font-semibold tracking-widest" style={{ color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>HASHTAG STUDIO</span>
          </a>

          {/* Desktop Nav */}
          <ul className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) =>
            <li key={link.label}>
                <a href={link.href} className="nav-link-gold text-sm tracking-widest">{link.label}</a>
              </li>
            )}
            <li>
              <button
                onClick={() => setCareerModalOpen(true)}
                className="nav-link-gold text-sm tracking-widest bg-transparent border-0 cursor-pointer">
                
                CAREER WITH US
              </button>
            </li>
            <li>
              <Link href="/booking" className="text-sm tracking-widest px-4 py-2 rounded-lg font-semibold gold-btn">BOOK NOW</Link>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden flex flex-col gap-1.5 p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu">
            
            <span className="block w-6 h-0.5" style={{ backgroundColor: '#d4af37' }} />
            <span className="block w-6 h-0.5" style={{ backgroundColor: '#d4af37' }} />
            <span className="block w-6 h-0.5" style={{ backgroundColor: '#d4af37' }} />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen &&
        <div className="lg:hidden" style={{ backgroundColor: '#0a0a0a', borderTop: '1px solid rgba(212,175,55,0.2)' }}>
            <ul className="flex flex-col py-4">
              {navLinks.map((link) =>
            <li key={link.label}>
                  <a
                href={link.href}
                className="block px-6 py-3 text-sm tracking-widest hover:text-yellow-400 transition-colors"
                style={{ color: '#fff' }}
                onClick={() => setMobileMenuOpen(false)}>
                
                    {link.label}
                  </a>
                </li>
            )}
              <li>
                <button
                onClick={() => {setCareerModalOpen(true);setMobileMenuOpen(false);}}
                className="block w-full text-left px-6 py-3 text-sm tracking-widest hover:text-yellow-400 transition-colors bg-transparent border-0"
                style={{ color: '#fff' }}>
                
                  CAREER WITH US
                </button>
              </li>
              <li>
                <Link href="/booking" className="block px-6 py-3 text-sm tracking-widest font-semibold" style={{ color: '#d4af37' }} onClick={() => setMobileMenuOpen(false)}>
                  BOOK NOW
                </Link>
              </li>
            </ul>
          </div>
        }
      </nav>

      {/* ══════════════════════════════════════════
           HERO BANNER
        ══════════════════════════════════════════ */}
      <section id="home" className="relative w-full">
        <div className="relative w-full overflow-hidden" style={{ maxHeight: '600px' }}>
          <img
            src="https://www.hashtagstudio.in/banner.jpg"
            alt="Hashtag Hair & Beauty Studio - Premium salon in Kolkata featuring hair styling and beauty services"
            className="w-full object-cover"
            style={{ maxHeight: '600px', objectPosition: 'center top' }} />
          
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 100%)' }} />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <div className="mb-4">
              <Image
                src="/assets/images/Hashtag_Logo-1788765015476.jpg"
                alt="Hashtag Hair & Beauty Studio Logo"
                width={100}
                height={100}
                className="rounded-full mx-auto object-cover"
                style={{ border: '3px solid #d4af37', boxShadow: '0 0 30px rgba(212,175,55,0.5)' }} />
              
            </div>
            <p className="text-sm tracking-[0.3em] mb-2" style={{ color: '#d4af37' }}>WELCOME TO</p>
            <h1 className="text-4xl md:text-6xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif', textShadow: '2px 2px 8px rgba(0,0,0,0.8)' }}>
              Hashtag Hair &amp; Beauty Studio
            </h1>
            <h4 className="text-xl md:text-2xl font-light mb-6" style={{ color: '#d4af37', fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic' }}>
              Where Style Meets Soul
            </h4>
            <p className="max-w-2xl text-gray-200 text-base md:text-lg leading-relaxed">
              At Hashtag, we believe beauty isn&apos;t just seen—it&apos;s felt. Our space is more than a salon; it&apos;s a vibe, a retreat, and your personal glam station. Whether you&apos;re after a bold transformation or subtle refresh, our expert stylists craft looks that speak your language.
            </p>
            <div className="mt-8 flex flex-wrap gap-4 justify-center">
              <a
                href="#services"
                className="gold-btn px-8 py-3 rounded-full text-sm font-semibold tracking-widest uppercase">
                
                Our Services
              </a>
              <a
                href="#contact-form"
                className="px-8 py-3 rounded-full text-sm font-semibold tracking-widest uppercase transition-all hover:bg-white hover:text-black"
                style={{ border: '2px solid #d4af37', color: '#d4af37' }}>
                
                Book Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           SERVICES SECTION
        ══════════════════════════════════════════ */}
      <section id="services" className="py-20 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle subtitle="Pamper yourself with our premium, trend-driven beauty services">
            💆‍♀️ Our Services
          </SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service) =>
            <div key={service.title} className="service-card rounded-2xl p-6 text-center">
                <div className="text-4xl mb-3">{service.icon}</div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>
                  {service.title}
                </h3>
                <ul className="space-y-2">
                  {service.items.map((item) =>
                <li key={item} className="text-gray-300 text-sm py-1" style={{ borderBottom: '1px solid rgba(212,175,55,0.1)' }}>
                      {item}
                    </li>
                )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           GALLERY GRID (6 images)
        ══════════════════════════════════════════ */}
      <section id="gallery" className="py-16 px-4" style={{ backgroundColor: '#000' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>✨ Style Gallery</SectionTitle>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {galleryImages.map((img) =>
            <div
              key={img.src}
              className="overflow-hidden rounded-xl cursor-pointer group"
              style={{ border: '1px solid rgba(212,175,55,0.2)' }}
              onClick={() => openModal(img.src, img.alt)}>
              
                <img
                src={img.src}
                alt={img.alt}
                className="w-full h-48 md:h-64 object-cover transition-transform duration-500 group-hover:scale-110" />
              
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           TREATMENTS GALLERY
        ══════════════════════════════════════════ */}
      <section id="treatment-gallery" className="py-16 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>💇‍♀️ Our Treatments Gallery</SectionTitle>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {/* Hair Treatment Image */}
            <div
              className="overflow-hidden rounded-xl cursor-pointer group"
              style={{ border: '1px solid rgba(212,175,55,0.2)' }}
              onClick={() => openModal('https://www.hashtagstudio.in/gellary/hair.jpg', 'Hair Treatment and Colour at Hashtag Studio Kolkata')}>
              
              <img
                src="https://www.hashtagstudio.in/gellary/hair.jpg"
                alt="Hair Treatment and Colour at Hashtag Studio Kolkata"
                className="w-full object-cover transition-transform duration-500 group-hover:scale-110"
                style={{ height: '330px', objectFit: 'cover' }} />
              
            </div>
            {/* Hydrafacial Video */}
            <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(212,175,55,0.2)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '330px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/hydrafacial.mp4" type="video/mp4" />
              </video>
            </div>
            {/* Hair Treatment Video */}
            <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(212,175,55,0.2)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '330px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/hair-treatment-video.mp4" type="video/mp4" />
              </video>
            </div>
            {/* Pedicure Video */}
            <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(212,175,55,0.2)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '330px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/pedicure.mp4" type="video/mp4" />
              </video>
            </div>
            {/* Hair Transplant Video */}
            <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(212,175,55,0.2)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '330px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/hair-transplant.mp4" type="video/mp4" />
              </video>
            </div>
            {/* Hair Transplant Video 2 */}
            <div className="overflow-hidden rounded-xl" style={{ border: '1px solid rgba(212,175,55,0.2)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '330px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/hair-transplant-video.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           NAIL ART GALLERY
        ══════════════════════════════════════════ */}
      <section id="nail-art-gallery" className="py-16 px-4" style={{ backgroundColor: '#000' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>💅 Nail Art Gallery</SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {nailArtImages.map((img) =>
            <div
              key={img.src}
              className="overflow-hidden rounded-xl cursor-pointer group"
              style={{ border: '1px solid rgba(212,175,55,0.2)' }}
              onClick={() => openModal(img.src, img.alt)}>
              
                <img
                src={img.src}
                alt={img.alt}
                className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" />
              
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           TATTOO SERVICE
        ══════════════════════════════════════════ */}
      <section id="tattoo-service" className="py-16 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>🎨 Tattoo Service</SectionTitle>
          <div className="flex justify-center">
            <div className="w-full max-w-sm overflow-hidden rounded-xl" style={{ border: '2px solid rgba(212,175,55,0.4)' }}>
              <video
                className="w-full object-cover"
                style={{ height: '400px', objectFit: 'cover' }}
                autoPlay
                muted
                loop
                playsInline>
                
                <source src="https://www.hashtagstudio.in/gellary/VID-20250726-WA0006.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           PMU SERVICES
        ══════════════════════════════════════════ */}
      <section className="py-16 px-4" style={{ backgroundColor: '#000' }}>
        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl p-8" style={{ background: '#111', border: '1px solid rgba(212,175,55,0.4)' }}>
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>
              💄 PMU Services (Permanent Makeup)
            </h3>
            <ul className="space-y-3 mb-6">
              {['Eyebrow Microblading', 'Lip Coloring', 'Eyelash Extensions', 'PMU Touch-up Services'].map((item) =>
              <li key={item} className="flex items-center gap-3 text-gray-200">
                  <span className="text-green-400">✅</span>
                  <span>{item}</span>
                </li>
              )}
            </ul>
            <p className="text-gray-400 mb-6">Get a long-lasting natural look with our certified PMU artists.</p>
            <a
              href="#contact-form"
              className="inline-block px-8 py-3 rounded-full text-sm font-semibold tracking-widest uppercase transition-all hover:bg-yellow-500"
              style={{ border: '2px solid #d4af37', color: '#d4af37' }}>
              
              Book Your PMU Appointment
            </a>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           CUSTOMER REVIEWS
        ══════════════════════════════════════════ */}
      <section id="customer-reviews" className="py-20 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-3xl mx-auto">
          <SectionTitle>⭐ What Our Customers Say</SectionTitle>
          <div className="relative">
            <div className="review-card rounded-2xl p-8 text-center">
              <img
                src={reviews[currentReview].image}
                alt={reviews[currentReview].alt}
                className="w-20 h-20 rounded-full object-cover mx-auto mb-4"
                style={{ border: '3px solid #d4af37' }} />
              
              <h5 className="text-xl font-semibold mb-2" style={{ color: '#d4af37' }}>{reviews[currentReview].name}</h5>
              <div className="flex justify-center mb-3">
                <StarRating rating={reviews[currentReview].rating} />
              </div>
              <p className="text-gray-300 text-base leading-relaxed italic">&ldquo;{reviews[currentReview].text}&rdquo;</p>
            </div>
            {/* Controls */}
            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length)}
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ background: '#d4af37', color: '#000' }}
                aria-label="Previous review">
                
                ‹
              </button>
              <div className="flex gap-2 items-center">
                {reviews.map((_, i) =>
                <button
                  key={i}
                  onClick={() => setCurrentReview(i)}
                  className="w-2.5 h-2.5 rounded-full transition-all"
                  style={{ backgroundColor: i === currentReview ? '#d4af37' : 'rgba(212,175,55,0.3)' }}
                  aria-label={`Go to review ${i + 1}`} />

                )}
              </div>
              <button
                onClick={() => setCurrentReview((prev) => (prev + 1) % reviews.length)}
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ background: '#d4af37', color: '#000' }}
                aria-label="Next review">
                
                ›
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           WHY CHOOSE US
        ══════════════════════════════════════════ */}
      <section id="why-us" className="py-20 px-4" style={{ backgroundColor: '#000' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>🌿 Why Choose Us?</SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
            { icon: '🎯', text: 'Personalized Consultations' },
            { icon: '✨', text: 'Hygienic, Relaxing Ambience' },
            { icon: '💯', text: 'Transparent Pricing' },
            { icon: '🔬', text: 'Latest Techniques & Safe Formulations' },
            { icon: '📍', text: 'Centrally Located for Your Convenience' },
            { icon: '🏆', text: 'Award-Winning Expert Stylists' }].
            map((item) =>
            <div
              key={item.text}
              className="flex items-center gap-4 p-5 rounded-xl transition-all hover:border-yellow-500"
              style={{ border: '1px solid rgba(212,175,55,0.3)', background: '#0a0a0a' }}>
              
                <span className="text-3xl">{item.icon}</span>
                <h4 className="font-semibold text-base uppercase tracking-wide" style={{ color: '#d4af37' }}>{item.text}</h4>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           VISIT US
        ══════════════════════════════════════════ */}
      <section id="visit-us" className="py-16 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-3xl mx-auto">
          <div
            className="rounded-2xl p-8 text-center"
            style={{ background: '#111', border: '1px solid rgba(212,175,55,0.4)' }}>
            
            <h2 className="text-3xl font-bold mb-2" style={{ color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>📍 Visit Us</h2>
            <h3 className="text-xl font-semibold mb-6 text-white">Hashtag Hair &amp; Beauty Studio</h3>
            <div className="space-y-3">
              <p className="text-lg text-gray-200">
                <span className="text-yellow-400">📞</span>{' '}
                <a href="tel:7439821761" className="hover:text-yellow-400 transition-colors">7439821761</a>
              </p>
              <p className="text-lg text-gray-200">
                <span className="text-yellow-400">📬</span>{' '}
                <a href="mailto:foreversrijita@gmail.com" className="hover:text-yellow-400 transition-colors">foreversrijita@gmail.com</a>
              </p>
              <p className="text-lg text-gray-200">
                <span className="text-yellow-400">🏠</span>{' '}
                Jodhpur Park, Opposite EEDF Hospital main gate, Near South City Mall
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           INSTAGRAM SLIDER
        ══════════════════════════════════════════ */}
      <section id="menu" className="py-16" style={{ backgroundColor: '#000' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="gold-text">📸 Follow us on Instagram: </span>
              <a
                href="https://www.instagram.com/hashtaghairbeautystudio/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
                style={{ color: '#d4af37' }}>
                
                @hashtaghairbeautystudio
              </a>
            </h2>
            <div className="section-divider mt-4" />
          </div>
        </div>
        {/* Scrollable slider */}
        <div
          ref={sliderRef}
          className="overflow-x-auto scrollbar-hide cursor-pointer"
          style={{ paddingBottom: '8px' }}>
          
          <div className="flex gap-3 px-4" style={{ width: 'max-content' }}>
            {[...sliderImages, ...sliderImages].map((img, idx) =>
            <div
              key={idx}
              className="flex-shrink-0 overflow-hidden rounded-xl cursor-pointer group"
              style={{ border: '1px solid rgba(212,175,55,0.2)' }}
              onClick={() => openModal(img.src, img.alt)}>
              
                <img
                src={img.src}
                alt={img.alt}
                className="h-56 w-auto object-cover transition-transform duration-300 group-hover:scale-105"
                style={{ minWidth: '200px' }} />
              
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           WHY HASHTAG
        ══════════════════════════════════════════ */}
      <section id="why-hashtag" className="py-20 px-4" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle subtitle="Discover why clients trust us for beauty and wellness">
            🌟 Why Hashtag?
          </SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyCards.map((card) =>
            <div key={card.title} className="why-card rounded-2xl p-6 text-center">
                <h5 className="text-lg font-bold mb-3" style={{ color: '#d4af37' }}>{card.title}</h5>
                <p className="text-gray-400 text-sm leading-relaxed">{card.description}</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           CONTACT FORM + MAP
        ══════════════════════════════════════════ */}
      <section id="contact-form" className="py-20 px-4" style={{ backgroundColor: '#000' }}>
        <div className="max-w-7xl mx-auto">
          <SectionTitle>✉️ Get in Touch</SectionTitle>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Form */}
            <div className="rounded-2xl p-8" style={{ background: '#111', border: '1px solid rgba(212,175,55,0.3)' }}>
              <form onSubmit={handleFormSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: '#d4af37' }}>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                    placeholder="Enter your name"
                    required
                    className="contact-input w-full px-4 py-3 rounded-lg text-sm" />
                  
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: '#d4af37' }}>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleFormChange}
                    placeholder="XXXX-XXXXXXX"
                    required
                    className="contact-input w-full px-4 py-3 rounded-lg text-sm" />
                  
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: '#d4af37' }}>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    placeholder="you@example.com"
                    required
                    className="contact-input w-full px-4 py-3 rounded-lg text-sm" />
                  
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2" style={{ color: '#d4af37' }}>Which Service Interested In</label>
                  <textarea
                    name="service"
                    value={formData.service}
                    onChange={handleFormChange}
                    placeholder="Tell us what you&apos;re looking for..."
                    required
                    rows={4}
                    className="contact-input w-full px-4 py-3 rounded-lg text-sm resize-none" />
                  
                </div>
                <div className="text-center pt-2">
                  <button
                    type="submit"
                    className="gold-btn px-10 py-3 rounded-full text-sm font-semibold tracking-widest uppercase">
                    
                    Submit
                  </button>
                </div>
              </form>
            </div>
            {/* Map */}
            <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid rgba(212,175,55,0.3)', minHeight: '400px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.0209670426893!2d88.3648887!3d22.503396499999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0271898813dff1%3A0xf0d9250bff24a0a7!2sHashtag%20Hair%20%26%20Beauty%20Studio!5e0!3m2!1sen!2s!4v1755600457698!5m2!1sen!2s"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '400px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Hashtag Hair & Beauty Studio Location Map" />
              
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
           FOOTER
        ══════════════════════════════════════════ */}
      <footer style={{ backgroundColor: '#000', borderTop: '1px solid rgba(212,175,55,0.4)' }}>
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
            {/* Brand */}
            <div className="text-center md:text-left">
              <div className="flex items-center gap-3 justify-center md:justify-start mb-4">
                <Image
                  src="/assets/images/Hashtag_Logo-1788765015476.jpg"
                  alt="Hashtag Hair & Beauty Studio Logo"
                  width={60}
                  height={60}
                  className="rounded-full object-cover"
                  style={{ border: '2px solid #d4af37' }} />
                
                <div>
                  <p className="font-bold text-sm tracking-widest" style={{ color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>HASHTAG</p>
                  <p className="text-xs tracking-widest text-gray-400">HAIR &amp; BEAUTY STUDIO</p>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                The Exclusive Unisex Salon in your town acquainted with world-class tools and professionals for stunning looks and absolute luxury.
              </p>
            </div>

            {/* Quick Links */}
            <div className="text-center">
              <h4 className="font-bold text-sm tracking-widest mb-4" style={{ color: '#d4af37' }}>QUICK LINKS</h4>
              <nav className="flex flex-col gap-2">
                {navLinks.map((link) =>
                <a
                  key={link.label}
                  href={link.href}
                  className="text-gray-400 text-sm hover:text-yellow-400 transition-colors tracking-wider">
                  
                    {link.label}
                  </a>
                )}
                <button
                  onClick={() => setCareerModalOpen(true)}
                  className="text-gray-400 text-sm hover:text-yellow-400 transition-colors tracking-wider bg-transparent border-0 cursor-pointer text-center">
                  
                  CAREER WITH US
                </button>
              </nav>
            </div>

            {/* Contact */}
            <div className="text-center md:text-right">
              <h4 className="font-bold text-sm tracking-widest mb-4" style={{ color: '#d4af37' }}>CONTACT US</h4>
              <div className="space-y-2">
                <p className="text-gray-400 text-sm">
                  <a href="tel:7439821761" className="hover:text-yellow-400 transition-colors">📞 7439821761</a>
                </p>
                <p className="text-gray-400 text-sm">
                  <a href="mailto:foreversrijita@gmail.com" className="hover:text-yellow-400 transition-colors">📬 foreversrijita@gmail.com</a>
                </p>
                <p className="text-gray-400 text-sm">
                  🏠 Jodhpur Park, Near South City Mall
                </p>
              </div>
              {/* Social Media Icons */}
              <div className="flex items-center gap-4 justify-center md:justify-end mt-4">
                <a
                  href="https://www.facebook.com/HashtagHairBeautyStudio"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 hover:scale-110"
                  style={{ backgroundColor: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.4)' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#d4af37">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/hashtaghairbeautystudio/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 hover:scale-110"
                  style={{ backgroundColor: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.4)' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                  </svg>
                </a>
                <a
                  href="https://wa.me/917439821761"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="flex items-center justify-center w-9 h-9 rounded-full transition-all duration-200 hover:scale-110"
                  style={{ backgroundColor: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.4)' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#d4af37">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: '1px', background: 'linear-gradient(to right, transparent, #d4af37, transparent)' }} className="mb-6" />

          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-500 text-sm tracking-wide">
              © 2026 Hashtag Hair &amp; Beauty Studio all right are reserved
            </p>
          </div>
        </div>
      </footer>

      {/* Gradient animation keyframes */}
      <style jsx global>{`
        @keyframes gradientBG {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>);

}